
import { IFeedLongVideoData } from '../kisaan/interface';

import paths from '../paths';
import { FeedClient } from './axiosFeedClient';
import { IuplodeContentPayload } from './interface';

export const uploadContentApi = async (payload: IuplodeContentPayload): Promise<Object> => {
  try {
    const response = await FeedClient.post<IFeedLongVideoData>(
      paths.postContentInMastodon(),
      payload
    );
    return response.data;
  } catch (e) {
    throw e;
  }
};
